module.exports = __webpack_public_path__ + "img/in-person.591529c2.jpg";